var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddsquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.83333 10.4997H9.16667V7.16634H10V10.4997H13.3333V11.333H10V14.6663H9.16667V11.333H5.83333V10.4997ZM5 3.83301H14.1667C14.8297 3.83301 15.4656 4.0964 15.9344 4.56524C16.4033 5.03408 16.6667 5.66997 16.6667 6.33301V15.4997C16.6667 16.1627 16.4033 16.7986 15.9344 17.2674C15.4656 17.7363 14.8297 17.9997 14.1667 17.9997H5C4.33696 17.9997 3.70107 17.7363 3.23223 17.2674C2.76339 16.7986 2.5 16.1627 2.5 15.4997V6.33301C2.5 5.66997 2.76339 5.03408 3.23223 4.56524C3.70107 4.0964 4.33696 3.83301 5 3.83301ZM5 4.66634C4.55797 4.66634 4.13405 4.84194 3.82149 5.1545C3.50893 5.46706 3.33333 5.89098 3.33333 6.33301V15.4997C3.33333 15.9417 3.50893 16.3656 3.82149 16.6782C4.13405 16.9907 4.55797 17.1663 5 17.1663H14.1667C14.6087 17.1663 15.0326 16.9907 15.3452 16.6782C15.6577 16.3656 15.8333 15.9417 15.8333 15.4997V6.33301C15.8333 5.89098 15.6577 5.46706 15.3452 5.1545C15.0326 4.84194 14.6087 4.66634 14.1667 4.66634H5Z",
    fill: "#008DFF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddsquare);
export default __webpack_public_path__ + "static/media/addsquare.5bea4103affeb2a8c646b724e5e7ae92.svg";
export { ForwardRef as ReactComponent };